import { Info } from "lucide-react";
import type { Id } from "@/packages/types";

interface AuditContextBadgeProps {
  audit: { id: Id<"audits">; displayName: string; code: string };
}

/**
 * Read-only badge shown in the upload sheet when opened from audit-view mode.
 * Indicates that uploaded documents will be scoped to this specific audit.
 */
export function AuditContextBadge({ audit }: AuditContextBadgeProps) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-accent/20 bg-accent/5 px-4 py-3 mb-4">
      <Info size={16} className="text-accent mt-0.5 shrink-0" />
      <div className="min-w-0">
        <span className="text-sm font-medium text-primary">
          {audit.displayName} ({audit.code})
        </span>
        <p className="text-xs text-muted mt-0.5">
          Matching will be scoped to this audit.
        </p>
      </div>
    </div>
  );
}
